// extracted by mini-css-extract-plugin
var _1 = "Message-module__animateUploadProgressBarWidth--k6pUL";
var _2 = "Message-module__animatedBackground--pkQ9l";
var _3 = "Message-module__dots--Nb6tI";
var _4 = "Message-module__errorMessage--eyckG";
var _5 = "Message-module__hasMessages--gOKUq";
var _6 = "Message-module__isEditing--jjXYd";
var _7 = "Message-module__isOpen--_8x9i";
var _8 = "Message-module__lastMessageExchange--gnQ1u";
var _9 = "Message-module__loadingIndicator--N_06S";
var _a = "Message-module__message--HgqBN";
var _b = "Message-module__messagesContainer--lhTqw";
var _c = "Message-module__overflowMenuButton--jwHQB";
var _d = "Message-module__overflowMenuContainer--VM84F";
var _e = "Message-module__overflowMenuFloating--tuZx2";
var _f = "40px";
var _10 = "Message-module__postPills--BNtPK";
var _11 = "Message-module__system--uRHrb";
var _12 = "Message-module__user--sSo4M";
var _13 = "Message-module__userMessageContent--VFRsH";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "dots", _4 as "errorMessage", _5 as "hasMessages", _6 as "isEditing", _7 as "isOpen", _8 as "lastMessageExchange", _9 as "loadingIndicator", _a as "message", _b as "messagesContainer", _c as "overflowMenuButton", _d as "overflowMenuContainer", _e as "overflowMenuFloating", _f as "paddingBottom", _10 as "postPills", _11 as "system", _12 as "user", _13 as "userMessageContent" }
